<template>
  <div class="py-2 accessorContainer d-flex justify-space-between">
    <div>
      <ACLAvatar
        :accessor="accessor"
        :avatar-props="{ size: 28 }"
      />
      <span class="ml-3 mr-4 text-truncate ">
        {{ accessor.displayName }}
      </span>
    </div>
    <div class="d-flex justify-end">
      <v-icon
        v-if="addedIcon"
        class="pa-1"
        :size="14"
        color="green"
      >
        add_circle
      </v-icon>
      <v-icon
        v-if="removedIcon"
        class="pa-1"
        :size="14"
        color="red"
      >
        remove_circle
      </v-icon>
      <span v-if="showPermission" class="ml-auto accessorPermission">
        {{ $t(`permissions.${accessor.permission}`) }}
      </span>
      <v-icon
        v-if="closable"
        :size="14"
        class="pa-1"
        @click.stop="close"
      >
        close
      </v-icon>
    </div>
  </div>
</template>
<script>
import ACLAvatar from './ACLAvatar';

export default {
  name: 'AccessorInfo',
  components: {
    ACLAvatar,
  },
  props: {
    accessor: {
      type: Object,
      required: true,
    },
    showPermission: {
      type: Boolean,
      default: true,
    },
    removedIcon: {
      type: Boolean,
      default: false,
    },
    addedIcon: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close', this.accessor);
    },
  },
};
</script>
<style scoped>
.accessorContainer {
  flex-wrap: nowrap;
  align-items: center;
}

.accessorPermission {
  color: #b8b8b8;
}
</style>
